import loadable from "@loadable/component"
import React from "react"

const LandingForm = loadable(() => import("./LandingForm"))
const SalesForm = loadable(() => import("./SalesForm"))
const StandardForm = loadable(() => import("./StandardForm"))

const Form = ({ component, grid }) => {
  if (component?.variant === "sales") {
    return <SalesForm component={component} grid={grid} />
  } else if (component?.variant === "landing") {
    return <LandingForm component={component} />
  } else {
    return <StandardForm component={component} grid={grid} />
  }
}

export default Form
